export const employees = [

	{	
		name:		"Carl Svärd",
		phone:		"+4670-878 94 79",
		mail:		"carl.svard@kayenta.se",
		linkedin:	"https://www.linkedin.com/in/carl-svard/"
	},
	{	
		name:		"David Svensson",
        phone:		"+4670-674 62 23",
        mail:		"david.svensson@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/davidsvnssn"
	},
	{
		name:		"Fabian Karlsson",
        phone:		"+4670-373 46 84",
        mail:		"fabian.karlsson@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/fabiankarlsson"
	},
	{
		name:		"Jonas Gullin",
        phone:		"+4673-625 51 03",
        mail:		"jonas.gullin@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/jonas-gullin-2427411"
	},
	{
		name:		"Karl-Oskar Zinderland",
        phone:		"+4679-339 12 95",
        mail:		"karl.oskar.johannesson@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/kalle-johannesson-6a618930"
	},
	{
		name:		"Kevin Dee Boman",
        phone:		"+4670-942 04 72",
        mail:		"kevin.dee.boman@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/kevin-db"
	},
	{
		name:		"Patrick Baumann",
        phone:		"+4670-855 04 69",
        mail:		"patrick.baumann@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/patrick-baumann"
	},
	{
		name:		"Philip Ejenstam",
        phone:		"+4670-750 97 30",
        mail:		"philip.ejenstam@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/philip-ejenstam-12bab6129"
	},
	{
		name:		"Robin Bolin",
        phone:		"+4670-311 72 81",
        mail:		"robin.bolin@kayenta.se",
        linkedin:	"https://www.linkedin.com/in/robinbolin"
	},
]
